import { onReady } from '../../shared/utils/helpers';
import Base from '../../components/base/base';
import Header from '../../components/header/header';
import PageLoader from '../../components/page-loader/page-loader';
import './work-with-me.scss';

interface WorkWithMePageOptions {
  debug?: boolean;
  [key: string]: any;
}

class WorkWithMePage extends Base {
  private header: Header;

  private loader: PageLoader;

  constructor(options: WorkWithMePageOptions = {}) {
    super(options.debug || false);
    this.debug = options.debug || false;

    this.header = new Header({ debug: this.debug });
    this.loader = new PageLoader({
      debug: this.debug,
      oncePerPageSession: true,
      pageKey: window.location.pathname,
    });

    this.init();
  }

  init(): void {
    this.loader.start();
    this.log('WorkWithMePage initialized');
  }
}

onReady(() => {
  new WorkWithMePage({ debug: true });
});

export default WorkWithMePage;
